import { useCallback } from 'react';

import styles from './style.module.css';

// A labelled group of radio options, each a full-width row. The chosen row
// takes the accent tint and the hard shadow; the native radio stays visible,
// so the choice never rests on colour alone. One handler serves every row and
// reads the value from the input itself.
export function ChoiceList({ ref, name, legend, intro, options, value, onChange, error }) {
  const onInput = useCallback(function({ currentTarget }) {
    onChange(currentTarget.value);
  }, [ onChange ]);

  // The options point at the message only while there is one.
  let describedBy = null;

  if (typeof error === 'string') {
    describedBy = `${ name }-error`;
  }

  // The ref lands on the first option, which is where focus goes when the
  // group is refused with nothing chosen.
  const rows = options.map(function({ key, label }, index) {
    let target = null;

    if (index === 0) {
      target = ref;
    }

    return (
      <label key={ key } className={ styles.option }>
        <input ref={ target } className={ styles.radio } type='radio' name={ name } value={ key } checked={ value === key } onChange={ onInput } aria-invalid={ typeof error === 'string' } aria-describedby={ describedBy }/>

        { label }
      </label>
    );
  });

  let note = null;

  if (typeof intro === 'string') {
    note = <span className={ styles.intro }>{ intro }</span>;
  }

  let message = null;

  if (typeof error === 'string') {
    message = <span id={ `${ name }-error` } className={ styles.error } role='alert'>{ error }</span>;
  }

  return (
    <fieldset className={ styles.group }>
      <legend className={ styles.legend }>{ legend }</legend>

      { note }

      { rows }

      { message }
    </fieldset>
  );
}
